module.exports = __webpack_public_path__ + "static/media/sprout.ae84e4ba.svg";